module.exports = __webpack_public_path__ + "static/media/lithium-battery.4ac53870.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/features/lithium-battery.png
// module id = 1223
// module chunks = 0